import React, { type JSX } from 'react';
import { ListedUser } from 'helper/users';
import TooltipWrapper from 'components/DesignSystem/TooltipWrapper';
import Switch from 'components/DesignSystem/Switch';
import EditUserButton from './EditUserButton';
import ResetPasswordButton from './ResetPasswordButton';
import SendTokenButton from './SendTokenButton';
import { confirmationDialog } from './utils';

export default function UserActions({
  user, setConfirmationDialogBox, toggled, changeUserActivity,
}: {
  user: ListedUser,
  setConfirmationDialogBox: (open: boolean, body: JSX.Element, confirm: () => void) => void,
  toggled: boolean,
  changeUserActivity: () => void,
}) {
  return (
    <>
      <span className="me-1 h-100 d-flex align-items-center">
        <TooltipWrapper title={toggled ? 'Desabilitar usuário' : 'Habilitar usuário'}>
          <Switch
            checked={toggled}
            onClick={() => {
              setConfirmationDialogBox(true, confirmationDialog(toggled), changeUserActivity);
            }}
          />
        </TooltipWrapper>
      </span>
      <SendTokenButton userId={user.id} />
      <ResetPasswordButton userId={user.id} username={user.username} />
      <EditUserButton userId={user.id} />
    </>
  );
}
